export default "__VITE_ASSET__jcuEoJ$X__"